import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/shared/ui/button';

interface CatalogSectionHeaderProps {
  title: string;
  subtitle: string;
}

export function CatalogSectionHeader({ title, subtitle }: CatalogSectionHeaderProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <header className="flex items-start gap-3">
      <Button asChild type="button" variant="ghost" size="icon" className="mt-0.5 shrink-0">
        <Link
          to="/app/catalog"
          aria-label={t('catalog.back_to_index')}
          title={t('catalog.back_to_index')}
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
        </Link>
      </Button>
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">{title}</h2>
        <p className="text-muted-foreground text-sm">{subtitle}</p>
      </div>
    </header>
  );
}
